import {PAGE_COUNT} from "../config";

export const pageFromList = (list) => {
    const copy = [...list];
    if(list && list.length > PAGE_COUNT){
        copy.pop();
        return copy;
    }
    return copy;
};